import { Icon, IconButton, TextField } from '@monash/portal-react';
import c from './sub-category-inputs.module.scss';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import SubcategoriesDropdown from './sub-categories-dropdown/SubcategoriesDropdown';
import InlineErrorMessage from '../../../../../common/inline-error-message/InlineErrorMessage';
import {
  LINKS_INLINE_ERROR_MSGS,
  MAX_CATEGORY_WEIGHT,
  MIN_CATEGORY_WEIGHT,
} from '../../../constants';

const SubcategoryInputs = ({
  categoryIndex,
  subcategoryIndex,
  removeSubcategory,
  subcategoriesFieldName,
  disabled,
}) => {
  const {
    trigger,
    formState: { errors, isSubmitted },
  } = useFormContext();

  const namePrefix = `${subcategoriesFieldName}.${subcategoryIndex}`;
  const idFieldName = `${namePrefix}.id`;

  const watchedId = useWatch({ name: idFieldName });

  const getError = () => {
    const subcategoryErrors =
      errors.categories?.[categoryIndex]?.subcategories?.[subcategoryIndex];

    const idError = subcategoryErrors?.id;
    const weightError = subcategoryErrors?.weight;

    if (idError) return [idError, idError.message];
    if (weightError) return [weightError, weightError.message];
    return [null, null];
  };

  const [subcatError, subcatErrorMsg] = getError();

  // This component is specifically designed to render in a 3 column grid
  return (
    <>
      <Controller
        name={idFieldName}
        rules={{ required: LINKS_INLINE_ERROR_MSGS.SUB_CATEGORY }}
        render={({ field: { value, onChange, onBlur } }) => (
          <SubcategoriesDropdown
            categoryIndex={categoryIndex}
            subcategoryIndex={subcategoryIndex}
            value={value}
            onBlur={onBlur}
            onChange={(e) => {
              onChange(e);
              isSubmitted && trigger(idFieldName); // Manually validate b/c dropdown's onBlur doesn't validate on first blur
            }}
            disabled={disabled}
          />
        )}
      />
      <Controller
        name={`${namePrefix}.weight`}
        rules={{
          min: {
            value: MIN_CATEGORY_WEIGHT,
            message: LINKS_INLINE_ERROR_MSGS.CATEGORY_WEIGHT,
          },
          max: {
            value: MAX_CATEGORY_WEIGHT,
            message: LINKS_INLINE_ERROR_MSGS.CATEGORY_WEIGHT,
          },
          validate: {
            isInteger: (value) => {
              if (!Number.isInteger(value))
                return LINKS_INLINE_ERROR_MSGS.CATEGORY_WEIGHT;
            },
          },
        }}
        render={({ field: { value, onChange, onBlur } }) => (
          <TextField
            value={value}
            onChange={(e) => onChange(parseInt(e.target.value))}
            onBlur={onBlur}
            type="number"
            min={MIN_CATEGORY_WEIGHT}
            max={MAX_CATEGORY_WEIGHT}
            disabled={disabled || !watchedId}
          />
        )}
      />
      <div className={c.deleteButtonContainer}>
        <IconButton
          icon={Icon.X}
          color="var(--card-text-color)"
          onClick={() => removeSubcategory(subcategoryIndex)}
          disabled={disabled}
        />
      </div>
      {subcatError && (
        <InlineErrorMessage className={c.error} message={subcatErrorMsg} />
      )}
    </>
  );
};

export default SubcategoryInputs;
